import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinhinjewadipune() {



const cardData = {
  keyword: "Taxi Service in Hinjewadi Pune",
  heading: "Lotus Cab: Taxi Service in Hinjewadi Pune",

  headingDescription:
    "Lotus Cab offers reliable Taxi Service in Hinjewadi Pune for corporate professionals, airport travelers, and families. Hinjewadi is Pune’s largest IT hub with multiple business parks across Phase 1, Phase 2, and Phase 3, requiring dependable transportation throughout the day. Our AC sedans and spacious SUVs are ideal for daily office commute, airport transfers, and outstation travel. Drivers are background-verified and familiar with peak-hour IT traffic routes. Transparent pricing with no hidden charges ensures complete fare clarity. With 24/7 online booking and quick pickup across Hinjewadi, we provide safe, comfortable, and punctual taxi service.",

  top: "Top Places to Visit Near Hinjewadi with Lotus Cab",

  topPlaces: [
    {
      title: "Rajiv Gandhi Infotech Park",
      description:
        "Rajiv Gandhi Infotech Park is the core of Hinjewadi’s IT ecosystem. It houses global companies across Phase 1, Phase 2, and Phase 3. Thousands of professionals commute daily. Reliable taxi service ensures punctual office travel. Peak traffic management is essential in this area. Corporate cab service supports smooth commuting."
    },
    {
      title: "Balewadi High Street",
      description:
        "Balewadi High Street is a premium shopping and dining destination near Hinjewadi. It is popular for cafes, restaurants, and nightlife. Professionals often visit after office hours. Cab service ensures safe late-night travel. Well-connected from Hinjewadi phases. Ideal leisure destination."
    },
    {
      title: "Pune International Airport",
      description:
        "Pune Airport is a key travel hub for Hinjewadi professionals. Airport transfers are frequently booked from this IT zone. Timely pickup ensures no flight delays. 24/7 airport taxi service supports early morning and late-night flights. Comfortable vehicles enhance travel convenience. Reliable airport drop guaranteed."
    },
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s historical landmarks. It reflects the city’s Maratha heritage. Visitors explore the fort and evening light shows. Located in central Pune, it is easily accessible by cab. Comfortable travel makes sightseeing convenient. Ideal for weekend visits."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular trekking and historical destination near Pune. Families and professionals visit on weekends. Scenic views and fresh air attract tourists. Safe and experienced drivers are required for hill routes. SUV taxis are ideal for such trips. Comfortable cab travel ensures stress-free outing."
    },
    {
      title: "Pashan Lake",
      description:
        "Pashan Lake is a peaceful getaway near Hinjewadi. Ideal for morning walks and relaxation. Professionals often visit during weekends. Short cab ride makes it accessible. Calm surroundings offer refreshing break. Convenient local taxi service enhances visit."
    },
    {
      title: "Phoenix Marketcity",
      description:
        "Phoenix Marketcity is one of Pune’s largest malls. It offers shopping, dining, and entertainment. Families often travel from Hinjewadi to the mall. Taxi service ensures easy commute without parking stress. Comfortable AC ride improves shopping experience. Ideal family destination."
    },
    {
      title: "Baner",
      description:
        "Baner is a nearby residential and commercial area. It houses offices, cafes, and entertainment spots. Daily commuting between Baner and Hinjewadi is common. Taxi service ensures punctual travel. Well-connected road routes make it accessible. Reliable cab service supports daily transport."
    }
  ],

  services: [
    {
      name: "Hinjewadi Cab Service",
      description:
        "Reliable cab service across Hinjewadi Phase 1, 2, and 3. Ideal for office commute and daily travel. AC sedans and SUVs available. Professional drivers assigned. Transparent pricing maintained. Quick pickup guaranteed."
    },
    {
      name: "Hinjewadi Airport Taxi",
      description:
        "24/7 airport taxi from Hinjewadi to Pune Airport. Timely pickup ensured. Suitable for business and family travel. Comfortable AC vehicles provided. Transparent fare structure maintained. Stress-free airport transfer guaranteed."
    },
    {
      name: "Hinjewadi Outstation Taxi",
      description:
        "Outstation taxi service from Hinjewadi for long-distance travel. One-way and round-trip options available. Safe highway driving ensured. Clean vehicles maintained. Transparent per km billing. Reliable interstate journey guaranteed."
    },
    {
      name: "Corporate Taxi Hinjewadi",
      description:
        "Corporate cab service for IT professionals. Monthly billing options available. Executive sedan vehicles provided. Punctual office commute ensured. Professional drivers assigned. Ideal for business travel."
    },
    {
      name: "SUV Taxi Hinjewadi",
      description:
        "Spacious SUV taxis for family and group travel. Extra luggage capacity available. Comfortable long-distance ride ensured. Safe and smooth driving guaranteed. Ideal for airport and weekend trips."
    },
    {
      name: "Luxury Cab Hinjewadi",
      description:
        "Premium cab options for executive and VIP clients. Plush seating ensures comfort. Professional chauffeurs assigned. Well-maintained vehicles provided. Ideal for corporate events and airport transfers."
    },
    {
      name: "Affordable Taxi Hinjewadi",
      description:
        "Budget-friendly taxi service for daily commute. Transparent fare breakdown provided. No hidden charges applied. Reliable and safe travel ensured. Cost-effective transport solution."
    },
    {
      name: "Online Taxi Booking Hinjewadi",
      description:
        "Easy online booking available 24/7. Instant confirmation provided. Flexible scheduling supported. Secure and transparent booking process. Hassle-free travel planning ensured."
    }
  ],

  tableData: [
    ["Taxi Service in Hinjewadi", "Hinjewadi Cab Service"],
    ["Hinjewadi Airport Taxi", "Hinjewadi Phase 1 Cab"],
    ["Hinjewadi Phase 2 Taxi", "Hinjewadi Phase 3 Cab Service"],
    ["Hinjewadi IT Park Cab", "Hinjewadi Outstation Taxi"],
    ["Hinjewadi to Pune Airport Cab", "Affordable Taxi Hinjewadi"],
    ["Luxury Cab Hinjewadi", "SUV Taxi Hinjewadi"],
    ["Corporate Taxi Hinjewadi", "Online Taxi Booking Hinjewadi"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Fast Pickup in IT Park Zones",
      WhyChoosedescription:
        "Quick pickup across Hinjewadi Phase 1, 2, and 3. Drivers familiar with IT traffic routes. Reduced waiting time ensured."
    },
    {
      WhyChooseheading: "Transparent Pricing Policy",
      WhyChoosedescription:
        "Clear fare structure shared before booking. No hidden charges applied. Honest billing ensured."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Specialized service for IT professionals. Executive vehicles available. Monthly billing supported."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock taxi service available. Early morning and midnight rides supported."
    },
    {
      WhyChooseheading: "Experienced Drivers",
      WhyChoosedescription:
        "Background-verified drivers assigned. Safe and smooth driving ensured."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV categories available. Suitable for individual and group travel."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription:
        "Regularly serviced vehicles provided. Clean and comfortable interiors ensured."
    },
    {
      WhyChooseheading: "Reliable & Trusted Service",
      WhyChoosedescription:
        "On-time pickup and safe drop guaranteed. Stress-free travel experience ensured."
    }
  ]
};

const faqData = [
  { question: "Do you provide taxi service in Hinjewadi Phase 1, 2, and 3?", answer: "Yes, we provide cab service across all phases of Hinjewadi IT Park." },
  { question: "Is airport taxi available from Hinjewadi?", answer: "Yes, 24/7 airport taxi service is available." },
  { question: "Are SUVs available in Hinjewadi?", answer: "Yes, SUV taxis are available for family and group travel." },
  { question: "Do you provide outstation taxi from Hinjewadi?", answer: "Yes, one-way and round-trip outstation taxi service is available." },
  { question: "Is corporate billing available?", answer: "Yes, corporate and monthly billing options are supported." },
  { question: "Is online booking available?", answer: "Yes, online taxi booking is available 24/7." },
  { question: "Are toll charges included?", answer: "Toll charges are explained transparently before booking confirmation." },
  { question: "Is night taxi available?", answer: "Yes, 24/7 taxi service is available including late-night rides." },
  { question: "How is fare calculated?", answer: "Fare is calculated on per km or fixed pricing depending on trip type." },
  { question: "Do drivers know IT routes?", answer: "Yes, drivers are familiar with Hinjewadi IT Park routes and traffic conditions." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Patil",
    feedback:
      "Using Lotus Cab for daily office commute in Hinjewadi. Punctual drivers and clean vehicles. Transparent pricing with no hidden charges. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Radhika Sharma",
    feedback:
      "Booked airport taxi from Hinjewadi Phase 2. Cab arrived on time and ride was smooth. Comfortable and reliable service.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Sandeep Mehta",
    feedback:
      "Corporate cab service for IT meetings worked perfectly. Professional driver and well-maintained vehicle. Excellent experience.",
    rating: 5
  }
];
























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Hinjewadi Pune",
  "image": "https://lotuscab.com/assets/images/taxi-service-hinjewadi-pune.jpg", 
  "description": "Lotus Cab offers reliable taxi service in Hinjewadi, Pune, including airport transfers, local rides across Hinjewadi Phases 1, 2, and 3, IT Park pickups, outstation trips, corporate travel, and luxury or SUV cabs. Book online anytime with professional drivers for safe and comfortable journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/taxi-service-hinjewadi-pune"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Taxi Service in Hinjewadi Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi service in Hinjewadi, Pune with Lotus Cab. Affordable airport, local, outstation & corporate cabs for all Hinjewadi phases. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Taxi Service in Hinjewadi, Hinjewadi Cab Service, Hinjewadi Airport Taxi, Hinjewadi Phase 1 Cab, Hinjewadi Phase 2 Taxi, Hinjewadi Phase 3 Cab Service, Hinjewadi IT Park Cab, Hinjewadi Outstation Taxi, Hinjewadi to Pune Airport Cab, Affordable Taxi Hinjewadi, Luxury Cab Hinjewadi, SUV Taxi Hinjewadi, Corporate Taxi Hinjewadi, Online Taxi Booking Hinjewadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinhinjewadipune;